import api from './api';

export const employeeService = {
  /**
   * Get all employees with assignments and computed status
   * @returns {Promise}
   */
  getAll: async () => {
    const response = await api.get('/employees');
    return response.data.employees;
  },

  /**
   * Get active employees (those with active assignments)
   * @returns {Promise}
   */
  getActive: async () => {
    const response = await api.get('/employees/active');
    return response.data.employees;
  },

  /**
   * Get employees assigned to a specific project
   * @param {string} projectCode - Project code
   * @returns {Promise}
   */
  getByProject: async (projectCode) => {
    const response = await api.get(`/employees/project/${projectCode}`);
    return response.data.employees;
  },

  /**
   * Get employee by ID with assignments and computed status
   * @param {string} id - Employee ID (UUID)
   * @returns {Promise}
   */
  getById: async (id) => {
    const response = await api.get(`/employees/${id}`);
    return response.data.employee;
  },

  /**
   * Create new employee (simplified - only emp_id and name)
   * @param {Object} employeeData - { emp_id, name }
   * @returns {Promise}
   */
  create: async (employeeData) => {
    const response = await api.post('/employees', employeeData);
    return response.data.employee;
  },

  /**
   * Update employee (simplified - only name)
   * @param {string} id - Employee ID (UUID)
   * @param {Object} employeeData - { name }
   * @returns {Promise}
   */
  update: async (id, employeeData) => {
    const response = await api.put(`/employees/${id}`, employeeData);
    return response.data.employee;
  },

  /**
   * Delete employee (cascades to assignments and billing)
   * @param {string} id - Employee ID (UUID)
   * @returns {Promise}
   */
  delete: async (id) => {
    const response = await api.delete(`/employees/${id}`);
    return response.data;
  },

  /**
   * Batch upload employees with project assignments
   * @param {Array} records - Array of employee records with assignments
   * @returns {Promise} - { success, created, failed, errors }
   */
  batchUpload: async (records) => {
    const response = await api.post('/employees/batch', { records });
    return response.data;
  },
};
